import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { authApi, workspaceApi } from '@/lib/api';
import { safeEntityRef } from '@/lib/track';

// The single Clarity loader lives in public/index.html so it starts before
// React on every domain. This component adds SPA page identity and safe,
// non-PII segmentation without loading a second copy of the tracker.
export const ClarityAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    if (typeof window.clarity !== 'function') return;

    const path = location.pathname.slice(0, 200);
    const user = authApi.getCurrentUser();
    const workspace = workspaceApi.getCurrent();
    const plan = workspace?.subscription?.plan || 'free';

    window.clarity('set', 'page_path', path);
    window.clarity('set', 'auth_state', user?.id ? 'signed_in' : 'anonymous');
    window.clarity('set', 'plan', plan);
    window.clarity('set', 'workspace_ref', safeEntityRef(workspace?.id));
    window.clarity('set', 'workspace_type', String(workspace?.type || 'unknown').slice(0, 40));
    window.clarity('set', 'app_host', window.location.hostname.slice(0, 120));
    window.clarity('event', 'page_view');

    // Clarity hashes this ID in the browser. No email or client content is sent.
    if (user?.id) {
      window.clarity('identify', user.id, undefined, path);
    }
  }, [location.pathname]);

  return null;
};
